import { render, staticRenderFns } from "./LoginBaseCard.vue?vue&type=template&id=0a7232ed&scoped=true"
import script from "./LoginBaseCard.vue?vue&type=script&lang=js"
export * from "./LoginBaseCard.vue?vue&type=script&lang=js"
import style0 from "./LoginBaseCard.vue?vue&type=style&index=0&id=0a7232ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7232ed",
  null
  
)

export default component.exports